<mat-form-field appearance="outline" bmTheme="find-tracks-select">
  <mat-label>{{ lg.sortTrackBy.style.label }}</mat-label>
  <mat-select [(value)]="styleId" (selectionChange)="filterTracksByStyle($event)">
    <mat-option [value]="'all'">{{ lg.sortTrackBy.style.allStylesOption }}</mat-option>
    @for (style of getStyles(); track style) {
      <mat-option [value]="style.id">
        {{ style.title }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
